import React from 'react';

import PageHeader from '../components/PageHeader';
import ContactForm from '../components/ContactForm';

const Contact = () => {
    return (
    <>
        {/* page header - start */}
        <PageHeader
        />
        {/* page header - end */}

        {/* contact form section - start */}
        <div className="contact-form-section">
            <div className="contact-form-section-wrapper" style={{paddingTop: "0px"}}>
                <div className="container">
                    <div className="row gx-5 contact-form-section-row">
                        <div className=" col-10 offset-1">
                            {/* contact form - start */}
                            <ContactForm/>
                            {/* contact form - end */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* contact form section - end */}
    </>
    );
};

export default Contact;
